<template>
  <log-in class="couples-log-in">
    <img
      :src="require(`@/assets/lasting_couples_heart_icon.svg`)"
      alt="Lasting for Couples Icon"
      width="65"
      height="65"
    />
  </log-in>
</template>

<script>
import LogIn from "@/pages/LogIn";

export default {
  name: "CouplesLogIn",
  components: {
    LogIn,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
@import "@/style/variables.scss";
.couples-log-in {
  img {
    margin-bottom: 16px;
  }
}
</style>
